import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';
import { FamilyListItemFragment } from './FamilyListItemFragment';

const FamiliesListQuery = graphql.persisted(
  "FamiliesListQuery",
  graphql(`
    query FamiliesListQuery($schoolId: ID!) {
      school(id: $schoolId) {
        id
        name
        slug
        families {
          ...FamilyListItemFragment
        }
      }
    }
  `, [FamilyListItemFragment])
);

export { FamiliesListQuery };

export function useFamiliesListQuery(schoolId: string | undefined) {
  return useQuery(FamiliesListQuery, {
    variables: { schoolId: schoolId! },
    skip: !schoolId,
  });
}
